import { useCustomMutation } from "@/shared/hooks/useCustomMutation";
import { useQueryClient } from "@tanstack/react-query";
import CategoryService from "@/features/categories/service/categoryService";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export const useCategoryMutations = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const createCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.createCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            toast.success("Categoria criada com sucesso!");
            navigate("/categories");
        },
        onError: (error) => {
            console.error("Erro ao criar categoria:", error);
            toast.error("Erro ao criar categoria");
        },
    });

    const updateCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.updateCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            queryClient.invalidateQueries({ queryKey: ["get-category-by-id"] });
            toast.success("Categoria atualizada com sucesso!");
            navigate("/categories");
        },
        onError: (error) => {
            console.error("Erro ao atualizar categoria:", error);
            toast.error("Erro ao atualizar categoria");
        },
    });

    const deleteCategory = useCustomMutation({
        serviceInstance: CategoryService.Instance,
        selectAction: (service) => service.deleteCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["get-categories"] });
            toast.success("Categoria excluída com sucesso!");
        },
        onError: (error) => {
            console.error("Erro ao excluir categoria:", error);
            toast.error("Erro ao excluir categoria");
        },
    });

    return {
        createCategory,
        updateCategory,
        deleteCategory,
    };
};